import { render, staticRenderFns } from "./CockpitStringComponent.vue?vue&type=template&id=40b22900&scoped=true"
import script from "./CockpitStringComponent.vue?vue&type=script&lang=js"
export * from "./CockpitStringComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b22900",
  null
  
)

export default component.exports